import { Card, Box, Typography, Link } from "@mui/material";
import { Link as RouterLink } from 'react-router-dom';
import { CustomCardProps } from "./card.model";

const CustomCard: React.FC<CustomCardProps> = ({
    source,
    textContent,
    color,
    path,
    disabled = true,
    disableNav = false,
    onClick,
    sx
}) => {

    return (
        <>
            {disabled ? (
                // <div>
                    <Card
                        sx={{
                            display: 'inline-block',
                            width: '140px',
                            height: '160px',
                            verticalAlign: 'top',
                            backgroundColor: '#ffffff',
                            transition: 'height 0.2s ease-in-out',
                            position: 'relative',
                            border: '2px solid ' + color,
                            boxShadow: '0 0 4px 2px rgba(0, 0, 0, 0.04)',
                            ...(disabled && { opacity: 0.3 }),
                        }}
                    >
                        <Box
                            component="span"
                            sx={{
                                display: 'block',
                                padding: '20px 15px 10px',
                                textAlign: 'center',
                                borderRadius: '5px',
                                position: 'relative',
                                backgroundColor: '#ffffff',
                                transition: 'all 0.2s ease-in-out',
                                minHeight: '84px',

                            }}
                        >
                            <Box
                                sx={{
                                    display: 'inline-block',
                                    height: '70px',
                                    width: '70px',
                                    verticalAlign: 'top',
                                    background: '#ffffff',
                                    borderRadius: '50%',
                                    position: 'relative',
                                    cursor: 'default', // Prevent pointer cursor when disabled
                                }}
                            >
                                <Box
                                    sx={{
                                        position: 'absolute',
                                        top: 0,
                                        right: 0,
                                        bottom: 0,
                                        left: 0,
                                        transform: 'scale(2)',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }}
                                >
                                    <img src={source} alt="" style={{ width: '60%', height: 'auto' }} />
                                </Box>
                            </Box>
                        </Box>
                        <Typography
                            variant="body2"
                            sx={{
                                backgroundColor: '#F6F5EF',
                                fontSize: '1rem',
                                // fontFamily: 'Gotham',
                                color: '#fff', // text color
                                padding: '8px', // padding around text
                                position: 'absolute',
                                bottom: 0, // position at the bottom
                                left: 0,
                                right: 0,
                                textAlign: 'center', // center the text horizontally
                                borderRadius: '0 0 0px 0px', // rounded corners for the footer
                            }}
                        >
                            <span style={{ color: '#000' }}> {textContent}</span>
                        </Typography>
                    </Card>
                /* </div> */
            ) : (
                <Link component={RouterLink} to={(path == null || disableNav) ? "" : path} underline="none"
                >
                    <Card
                        sx={{
                            display: 'inline-block',
                            width: '140px',
                            height: '160px',
                            verticalAlign: 'top',
                            backgroundColor: '#ffffff',
                            transition: 'height 0.2s ease-in-out',
                            position: 'relative',
                            border: '2px solid ' + color,
                            boxShadow: '0 0 4px 2px rgba(0, 0, 0, 0.04)',
                        }}
                        {...disableNav?{onClick}:{}}
                    >
                        <Box
                            component="span"
                            sx={{
                                display: 'block',
                                padding: '20px 15px 10px',
                                textAlign: 'center',
                                borderRadius: '5px',
                                position: 'relative',
                                backgroundColor: '#ffffff',
                                transition: 'all 0.2s ease-in-out',
                                minHeight: '84px',
                            }}
                        >
                            <Box
                                sx={{
                                    display: 'inline-block',
                                    height: '70px',
                                    width: '70px',
                                    verticalAlign: 'top',
                                    background: '#ffffff',
                                    borderRadius: '50%',
                                    position: 'relative',
                                    cursor: 'pointer',
                                }}
                            >
                                <Box
                                    sx={{
                                        position: 'absolute',
                                        top: 0,
                                        right: 0,
                                        bottom: 0,
                                        left: 0,
                                        transform: 'scale(2)',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }}
                                >
                                    <img src={source} alt="" style={{ width: '60%', height: 'auto' }} />
                                </Box>
                            </Box>
                        </Box>
                        <Typography
                            variant="body2"
                            sx={{
                                backgroundColor: '#F6F5EF',
                                fontSize: '1rem',
                                // fontFamily: 'Gotham',
                                color: '#fff', // text color
                                padding: '8px', // padding around text
                                position: 'absolute',
                                bottom: 0, // position at the bottom
                                left: 0,
                                right: 0,
                                textAlign: 'center', // center the text horizontally
                                borderRadius: '0 0 0px 0px', // rounded corners for the footer
                            }}
                        >
                            <span style={{ color: '#000' }}> {textContent}</span>
                        </Typography>
                    </Card>
                </Link>
            )}
        </>
    );
}
export default CustomCard;